import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';

function normalizeUrl(value) {
  return value
    .trim()
    .replace(/^https?:\/\//i, '')
    .replace(/\/+$/, '')
    .toLowerCase();
}

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [storeUrl, setStoreUrl] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', {
        email: email.trim().toLowerCase(),
        storeUrl: normalizeUrl(storeUrl)
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Failed to send reset link');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-white">
      <div className="w-full max-w-sm">
        <div className="mb-10 flex flex-col items-center text-center">
          <img
            src="https://cdn.prod.website-files.com/6598727d8180e7b6c126a6cf/69344ca971a7628e577f32ab_runa_logo.png"
            alt="Runa"
            className="w-16 h-16 rounded-full mb-4"
          />
          <h1 className="text-2xl font-light tracking-tight">RUNA</h1>
        </div>

        <div className="mb-8 text-center">
          <h2 className="text-2xl font-semibold text-neutral-900">
            Forgot your password?
          </h2>
          <p className="text-sm text-neutral-500 mt-2">
            Enter your store URL and email — we'll send a reset link.
          </p>
        </div>

        {submitted ? (
          <div className="p-4 border border-green-200 bg-green-50 text-green-800 text-sm rounded">
            If an admin account exists for <strong>{storeUrl}</strong> with
            email <strong>{email}</strong>, a password reset link has been sent.
            Check your inbox (and spam folder).
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="p-4 border border-red-200 bg-red-50 text-red-700 text-sm">
                {error}
              </div>
            )}

            <div>
              <label className="label">Store URL</label>
              <input
                type="text"
                className="input"
                value={storeUrl}
                onChange={(e) => setStoreUrl(e.target.value)}
                required
                placeholder="mystore.com"
                autoComplete="username"
              />
            </div>

            <div>
              <label className="label">Email</label>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="jane@mystore.com"
                autoComplete="email"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary w-full mt-2"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <span className="spinner mr-2"></span>
                  Sending
                </span>
              ) : (
                'Send reset link'
              )}
            </button>
          </form>
        )}

        <p className="mt-8 text-center text-sm text-neutral-500">
          Remembered your password?{' '}
          <Link to="/login" className="link">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
